module.exports = __webpack_public_path__ + "img/holiday_supplies.6a453408.png";